import { ExecutionStatus, Filter } from '@qality/common-model';
import { StatusSelectOption } from '@qality/common-utils';

import { ALL_STATUSES, StatusOptions } from './TestCaseInCycleStatusFilter';

export const dedupeStatusOptions = (
  uniqueStatusOptions: Array<ExecutionStatus>,
  statusOption: ExecutionStatus
): Array<ExecutionStatus> => {
  const isDuplicate =
    uniqueStatusOptions.find((uniqueStatusOption) => {
      return uniqueStatusOption.id === statusOption.id;
    }) !== undefined;

  return isDuplicate
    ? uniqueStatusOptions
    : [...uniqueStatusOptions, statusOption];
};

export const handleAllStatusesOption = (
  statusOptions: StatusOptions
): StatusOptions => {
  const isNoStatusOptionSelected = statusOptions.length === 0;

  return isNoStatusOptionSelected ? [ALL_STATUSES] : statusOptions;
};

export const filterOutAllStatuses: Filter<StatusSelectOption> = (
  statusOption
) => {
  return statusOption.value !== ALL_STATUSES.value;
};
